// pp-pedido-fabricacion.js — el «− 80 +» de lo que se manda a hacer con tu
// logo (snippets/pp-pedido-fabricacion.liquid).
//
// El mínimo y el escalón NO se derivan aquí: son `min` y `step` del input, que
// pinta Liquid desde custom.moq y custom.multiplo. La regla es la MISMA que la
// fila de compra de la ficha (pp-main-product.js, `qtyValida`): hacia ARRIBA y
// contando los escalones desde el mínimo, no desde el cero. La prueba
// tests/pedido-fabricacion.test.mjs carea las dos con cientos de cantidades.
//
// Al moverse, rehace el desglose y lleva la cantidad al estudio: todos los
// «Personalizar con mi logo» de la ficha reciben `?cantidad=`.
(function () {
  'use strict';

  // ── Puras ───────────────────────────────────────────────────────────────
  function valida(n, min, paso) {
    if (!(min > 0)) min = 1;
    if (!isFinite(n) || n <= min) return min;
    if (!(paso > 0)) return min;               // sin escalón: sólo el mínimo
    return min + Math.ceil((n - min) / paso) * paso;
  }
  function conCantidad(href, n) {
    try {
      var u = new URL(href, 'https://print.parapaquetes.com');
      u.searchParams.set('cantidad', String(n));
      return u.toString();
    } catch (e) { return href; }
  }
  if (typeof window !== 'undefined') window.PPPedidoFabricacion = { valida: valida, conCantidad: conCantidad };
  if (typeof document === 'undefined') return;

  // ── DOM ─────────────────────────────────────────────────────────────────
  var raiz = document.querySelector('[data-pp-fab]');
  if (!raiz) return;
  var input = raiz.querySelector('[data-pp-fab-cantidad]');
  var menos = raiz.querySelector('[data-pp-fab-menos]');
  var mas = raiz.querySelector('[data-pp-fab-mas]');
  var ajuste = raiz.querySelector('[data-pp-fab-ajuste]');
  var renglon = raiz.querySelector('[data-pp-fab-renglon]');
  var subtotal = raiz.querySelector('[data-pp-fab-subtotal]');
  var total = raiz.querySelector('[data-pp-fab-total]');
  var grabadoEl = raiz.querySelector('[data-pp-fab-grabado]');
  var barra = raiz.querySelector('[data-pp-fab-barra]');
  var barraTotal = barra && barra.querySelector('[data-pp-fab-barra-total]');
  var barraCuantas = barra && barra.querySelector('[data-pp-fab-barra-cuantas]');
  var min = parseInt(input.getAttribute('min'), 10) || 1;
  var paso = input.hasAttribute('readonly') ? 0 : (parseInt(input.getAttribute('step'), 10) || 0);
  var precio = Number(raiz.getAttribute('data-precio')) || 0;      // centavos
  var grabado = Number(raiz.getAttribute('data-grabado')) || 0;    // centavos
  var unidad = raiz.getAttribute('data-unidad') || '';
  var T = {
    ajuste: raiz.getAttribute('data-t-ajuste') || '',
    ajusteMin: raiz.getAttribute('data-t-ajuste-min') || '',
    renglon: raiz.getAttribute('data-t-renglon') || ''
  };

  function dinero(c) {
    return '$' + (Math.round(c) / 100).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  function miles(n) { return Number(n).toLocaleString('es-MX'); }

  function llevarAlEstudio(n) {
    var botones = document.querySelectorAll('a.pp-main-product__personalizar');
    Array.prototype.forEach.call(botones, function (a) { a.href = conCantidad(a.getAttribute('href'), n); });
  }

  function pintar(n) {
    renglon.textContent = T.renglon.replace('__N__', miles(n)).replace('__U__', unidad).replace('__P__', dinero(precio));
    subtotal.textContent = dinero(precio * n);
    total.textContent = dinero(precio * n + grabado) + ' MXN';
    // El formato de Liquid trae « MXN» y el del JS no: todo el desglose con el mismo.
    if (grabadoEl) grabadoEl.textContent = dinero(grabado);
    if (barraTotal) barraTotal.textContent = total.textContent;
    if (barraCuantas) barraCuantas.textContent = miles(n) + ' ' + unidad;
    menos.disabled = n <= min;
    llevarAlEstudio(n);
  }

  function decir(texto) { ajuste.textContent = texto || ''; ajuste.hidden = !texto; }

  function fijar(n, tecleado) {
    var bueno = valida(n, min, paso);
    input.value = String(bueno);
    if (tecleado && isFinite(n) && n !== bueno) {
      decir(n < min
        ? T.ajusteMin.replace('__MIN__', miles(min))
        : T.ajuste.replace('__N__', miles(bueno)).replace('__MIN__', miles(min)).replace(/__PASO__/g, miles(paso)));
    } else if (!tecleado) {
      decir('');
    }
    pintar(bueno);
  }

  menos.addEventListener('click', function () { fijar((parseInt(input.value, 10) || min) - paso, false); });
  mas.addEventListener('click', function () { fijar((parseInt(input.value, 10) || min) + paso, false); });
  // Lo tecleado se acomoda al SALIR del campo (o con Enter): corregir a media
  // tecla le pelea el número.
  input.addEventListener('change', function () { fijar(parseInt(input.value, 10), true); });
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });

  // ── La barra fija del celular ────────────────────────────────────────────
  // Va al <body> (un ancestro con transform/contain la encerraría). En celular
  // la página reserva su alto abajo (--pp-barra-compra-alto, como la barra de
  // compra) y `pp-pdp-sticky-visible` sube a Paco sobre ella.
  if (barra) {
    document.body.appendChild(barra);
    var celular = window.matchMedia('(max-width: 749px)');
    var reservar = function () {
      var alto = celular.matches ? Math.ceil(barra.getBoundingClientRect().height) : 0;
      if (alto) document.documentElement.style.setProperty('--pp-barra-compra-alto', alto + 'px');
      else document.documentElement.style.removeProperty('--pp-barra-compra-alto');
      document.body.classList.toggle('pp-pdp-sticky-visible', alto > 0);
    };
    reservar();
    if ('ResizeObserver' in window) new ResizeObserver(reservar).observe(barra);
    if (celular.addEventListener) celular.addEventListener('change', reservar);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { barra.classList.toggle('pp-fab-barra--total-a-la-vista', e.isIntersecting); });
      }, { threshold: 0 }).observe(total);
    }
  }

  fijar(min, false);
})();
